import { render } from "./Players.vue?vue&type=template&id=83b3324c&scoped=true"
import script from "./Players.vue?vue&type=script&lang=js"
export * from "./Players.vue?vue&type=script&lang=js"

import "./Players.vue?vue&type=style&index=0&id=83b3324c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dinho\\Documents\\GitHub\\Grajaú-E-SPORTS\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b3324c"]])

export default __exports__